import axios from 'axios';
import { replace, is } from 'ramda';
import elasticsearch from 'elasticsearch';
import { resolver } from '../util';
import config from '../../config';
import Queries from './queries';

const selectInScope = (startTime, endTime, elements) => {
  const inScopeValues = [];
  Object.keys(elements).forEach((idx) => {
    if (elements[idx] !== undefined) {
      if (elements[idx].created_at >= startTime && elements[idx].created_at <= endTime) {
        inScopeValues.push({
          traceId: elements[idx].trace_id,
          createdAt: elements[idx].created_at,
        });
      }
    }
  });
  return inScopeValues;
};

const getCalls = resolver.authenticatedResolver.createResolver(
  async (root, {
    appDomain, identifier, startTime, endTime,
  }) => {
    const currentDate = new Date();
    const routingAPI = `${config.mapServiceUrl}/idm/v1/domainpublicidinfo/domain/${appDomain}/publicid/${identifier}`;
    console.debug(`Routing API Call to ${routingAPI}`);
    let routingID = {};
    try {
      routingID = await axios({
        method: 'get',
        url: routingAPI,
        timeout: 5000,
        headers: {
          'Content-Type': 'application/json',
          'x-api-token': `${config.mapServiceToken}`,
        },
      });
    } catch (err) {
      return '';
    }

    const currentMili = currentDate.getTime();
    const traceTime = currentMili * 1000;
    const traceLimit = 1000; // 00;

    let rawtraceIDs = [];
    if (routingID.data !== undefined) {
      const traceAPI = `${config.mapServiceUrl}/evm/v1/traceid/routingid/${routingID.data.routingID}/time/${traceTime}/records/${traceLimit}`;
      try {
        rawtraceIDs = await axios({
          method: 'get',
          url: traceAPI,
          timeout: 5000,
          headers: {
            'Content-Type': 'application/json',
            'x-api-token': `${config.mapServiceToken}`,
          },
        });
      } catch (err) {
        return [];
      }
    }

    const finalTraceIds = selectInScope(startTime, endTime, rawtraceIDs.data);

    return finalTraceIds;
  },
);

const esSearch = query => new Promise((resolve, reject) => {
  const searchProps = { ...config.elasticProps };
  if (!is(Number, config.elasticProps.requestTimeout)) {
    searchProps.requestTimeout = parseInt(config.elasticProps.requestTimeout, 10);
  }
  const client = new elasticsearch.Client(searchProps);
  client.search(query.query, (error, response) => {
    let results = null;
    if (error) {
      const msg = 'There was an error getting data from Elastic Search';
      console.log(msg);
      reject(error);
    }
    if (response && !response.aggregations) {
      console.log('response.aggregations missing for query');
      console.log(response);
      resolve(response);
    }
    if (response && response.aggregations) {
      results = response.aggregations;
      resolve(results);
    }
  });
});

const getCallDetails = resolver.authenticatedResolver.createResolver(
  async (root, { startTime, endTime, traceIds }) => {
    const query = JSON.parse(JSON.stringify(Queries.CallDetailsQuery));
    query.query.body.query.bool.must[1].range['@timestamp'].gte = startTime;
    query.query.body.query.bool.must[1].range['@timestamp'].lte = endTime;
    let traceIdsStringList = `"${traceIds.join('","')}"`;
    if (traceIds.length === 1) {
      traceIdsStringList = traceIds.join(',');
    }
    let queryString = query.query.body.query.bool.must[0].query_string.query;
    queryString = replace(/###traceListPlaceholder###/, traceIdsStringList, queryString);
    query.query.body.query.bool.must[0].query_string.query = queryString;
    let searchResult = {};
    try {
      searchResult = await esSearch(query);
    } catch (err) {
      console.error('ES Search Returned error: ', err);
    }
    return searchResult;
  },
);

const getNtmTraceDetails = resolver.authenticatedResolver.createResolver(
  async (root, { startTime, endTime, traceIds }) => {
    const query = JSON.parse(JSON.stringify(Queries.NtmDetailsQuery));
    query.query.body.query.bool.must[1].range['@timestamp'].gte = startTime;
    query.query.body.query.bool.must[1].range['@timestamp'].lte = endTime;
    let traceIdsStringList = `"${traceIds.join('","')}"`;
    if (traceIds.length === 1) {
      traceIdsStringList = traceIds.join(',');
    }
    let queryString = query.query.body.query.bool.must[0].query_string.query;
    queryString = replace(/###traceListPlaceholder###/, traceIdsStringList, queryString);
    query.query.body.query.bool.must[0].query_string.query = queryString;
    let searchResult = {};
    const transformedResult = [];
    try {
      searchResult = await esSearch(query);
    } catch (err) {
      console.error('ES Search Returned error: ', err);
    }

    if (searchResult.hits && searchResult.hits.hits) {
      const data = searchResult.hits.hits;
      data.forEach((element) => {
        const source = element._source; // eslint-disable-line no-underscore-dangle
        const updatedSource = {};
        // get the fields and rename if required
        if (source['@timestamp']) {
          updatedSource.timestamp = source['@timestamp'];
        }
        if (source.message) {
          updatedSource.message = source.message;
        }
        if (source.Message) {
          updatedSource.Message = source.Message;
        }
        if (source.code) {
          updatedSource.code = source.code;
        }
        if (source.traceId) {
          updatedSource.traceId = source.traceId;
        }
        transformedResult.push(updatedSource);
      });
    }
    return transformedResult;
  },
);

export default {
  Query: {
    getCalls,
    getCallDetails,
    getNtmTraceDetails,
  },
};
